import { IGlobalMask } from '@/framework';
import { Framework } from '@/framework/instance';

export class Tip extends Framework {
    /** 设置模糊 */
    setBlur(blur: number) {
        this.framework.stage.blurStage.setBlur(blur);
    }

    /** 添加闪烁 */
    addShine(layerId: string, duration?: number) {
        return this.framework.addShine(layerId, duration);
    }

    /** 移除闪烁 */
    removeShine(layerId: string) {
        return this.framework.removeShine(layerId);
    }

    /**
     * 设置图层加载状态
     *
     * @param layerId - 图层 ID
     * @param extraInfo - 额外信息
     */
    setLoading(layerId: string, extraInfo?: string) {
        this.framework.setLoading(layerId, extraInfo);
    }

    /**
     * 移除图层加载状态
     *
     * @param layerId - 图层 ID
     * @param extraInfo - 额外信息
     */
    removeLoading(layerId: string, extraInfo?: string) {
        this.framework.removeLoading(layerId, extraInfo);
    }

    /**
     * 检查图层是否正在加载
     *
     * @param layerId - 图层 ID
     * @returns 是否正在加载
     */
    checkLoading(layerId: string) {
        return this.framework.checkIsLoading(layerId);
    }

    /**
     * 显示全局遮罩
     *
     * @param args - 全局遮罩参数
     */
    showMask(args: IGlobalMask) {
        this.framework.operate.globalMask.show(args);
    }

    /**
     * 隐藏全局遮罩
     */
    hideMask() {
        this.framework.operate.globalMask.hide();
    }

    /**
     * 监听全局遮罩
     *
     * @param callback - 回调函数
     * @param weight - 权重
     */
    onMask(
        callback: (args: { isShow: boolean; isHide: boolean; zIndex: number; data: IGlobalMask }) => void,
        weight = 0,
    ) {
        return this.framework.operate.globalMask.onMask(callback, weight);
    }
}
